import Base from "../../base/Base";
import Item from "./Item";

export default function Block(name) {

	//extend Base's Attributes.
	Base.call(this, arguments);

	this.name = name;

	this.items = [];
}


//extend Base's methods.
Block.prototype = new Base();
Block.prototype.constructor = Block;

//We use this method to get the full js Object.
Block.prototype.render = function (obj) {

	Base.prototype.render.call(this, obj);


	this.renderList("items", Item);


}


Block.prototype.addItem = function () {

	let item = new Item();
	item.editMode = true;

	this.items.push(item);
}


Block.prototype.validate = function () {

	if (!this.name) {
		this.errorMessage = "索引栏的名称必填";
		return false;
	}

	return true;

}

Block.prototype.getForm = function () {


	let itemsInfo = [];
	for (let i = 0; i < this.items.length; i++) {
		let item = this.items[i];

		itemsInfo.push(item.getForm());
	}
	return {
		name: this.name,
		items: itemsInfo
	};

}

Block.prototype.finish = function () {

	if (this.validate()) {
		this.errorMessage = null;
		this.editMode = false;
	}

}

Block.prototype.toggleEdit = function () {

	if (this.editMode) {
		this.finish();
	} else {
		this.editMode = true;
	}

}



// WEBPACK FOOTER //
// ./src/common/model/lover/theme/Block.js